<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_131_7425)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.7423 0.583328H5.28065L4.32136 2.33333H2.04183H0.583496V3.49999H2.04183V13.4167H11.9585V3.49999H13.4168V2.33333H11.9585H9.68231L8.7423 0.583328ZM8.35799 2.33333L8.04465 1.74999H5.97158L5.65181 2.33333H8.35799ZM10.309 3.5L10.7918 3.49999V12.25H3.2085V3.49999L3.68183 3.5H10.309ZM6.41683 5.24999V10.2083H5.25016V5.24999H6.41683ZM8.75016 10.2083V5.24999H7.5835V10.2083H8.75016Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
